/**
 * The two entry points into `/login`. Spread these into a `<Link>` rather than
 * hand-writing the target, so a "Sign in" CTA can never open the sign-up form
 * (and vice versa):
 *
 *   <Link {...SIGN_UP_LINK} className="…">Start for free</Link>
 */
export const SIGN_IN_LINK = { to: "/login" } as const;

export const SIGN_UP_LINK = {
  to: "/login",
  search: { mode: "signup" },
} as const;
